'use client';

import { type RoadMapUpdate } from '@/domain/roadmap/types';
import { useUsers } from '@/domain/user/hooks';
import { type UserBrief } from '@/domain/user/types';
import { useAuth } from '@/hooks/useAuth';
import { Autocomplete } from '@andritzot/metris-web-ui/inputs/autocomplete';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { type Control, Controller } from 'react-hook-form';

import { FieldActionsWrapper } from './shared/FieldActionsWrapper';

interface ReporterFieldProps {
  viewOnly: boolean;
  control: Control<RoadMapUpdate, unknown>;
}

export function ReporterField({ viewOnly, control }: Readonly<ReporterFieldProps>) {
  const { user } = useAuth();
  const { data: users } = useUsers({ enabled: !!user });

  return (
    <Box sx={{ py: 0.75, width: '100%' }}>
      <Controller
        name="reporter"
        control={control}
        render={({ field: { value, onChange } }) => (
          <FieldActionsWrapper copyValue={value?.name ?? ''}>
            <Autocomplete<UserBrief, false, false, false>
              value={value ?? null}
              onChange={(_, newValue) => onChange(newValue)}
              options={users ?? []}
              getOptionLabel={(u) => u.name}
              getOptionKey={(u) => u.idUser}
              isOptionEqualToValue={(opt, v) => opt.idUser === v.idUser}
              label="Reporter"
              placeholder="Search users..."
              disabled={viewOnly}
              fullWidth
              size="small"
            />
          </FieldActionsWrapper>
        )}
      />
    </Box>
  );
}
